import { IsDefined, IsInt, IsObject, IsOptional, IsString, IsDate, IsDecimal, IsArray } from 'class-validator';
import { BaseDto } from '../base.dto';
import type { PurchaseOrderInvoiceStatusDto } from './purchase-order-invoice-status.dto';
import type { PurchaseOrderInvoiceItemDto } from './purchase-order-invoice-item.dto';
import type { PurchaseOrderDto } from '../purchaseOrder.dto';
import type { MerchantDto } from '../merchant.dto';
import type { SupplierDto } from '../supplier.dto';

export class PurchaseOrderInvoiceDto extends BaseDto {
  @IsOptional()
  @IsInt()
  merchantId?: number;

  @IsOptional()
  @IsInt()
  supplierId?: number;

  @IsDefined()
  @IsInt()
  purchaseOrderInvoiceStatusId: number;

  @IsOptional()
  @IsInt()
  purchaseOrderId?: number;

  @IsOptional()
  @IsString()
  invoiceNo?: string;

  @IsOptional()
  @IsString()
  accountCode?: string;

  @IsOptional()
  @IsString()
  accountName?: string;

  @IsOptional()
  @IsDate()
  invoiceDate?: Date;

  @IsOptional()
  @IsString()
  reference?: string;

  @IsOptional()
  @IsDecimal()
  invoiceValue?: number;

  @IsOptional()
  @IsDecimal()
  invoiceVat?: number;

  @IsOptional()
  @IsDecimal()
  invoiceGrossValue?: number;

  @IsDefined()
  @IsString()
  fileCode: string;

  @IsOptional()
  @IsString()
  invoiceFileUrl?: string;

  /* Relationships */

  @IsOptional()
  @IsObject()
  merchant?: MerchantDto;

  @IsOptional()
  @IsObject()
  supplier?: SupplierDto;

  @IsOptional()
  @IsObject()
  purchaseOrderInvoiceStatus?: PurchaseOrderInvoiceStatusDto;

  @IsOptional()
  @IsObject()
  purchaseOrder?: PurchaseOrderDto;

  @IsOptional()
  @IsArray()
  purchaseOrderInvoiceItems?: PurchaseOrderInvoiceItemDto[];
}
